import { ControlInterface } from 'edocatbase/Form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { onFormChange } from '../../../actions/form';
import { remove } from 'ramda';
import { Dispatch } from 'redux';
import {  Table, TableBody, TableCell, TableHead, TableRow, Fab, Icon  } from "@mui/material";
import {  Add  } from "@mui/icons-material";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleModal } from '../../../../ModalTest/actions';

interface TableProps extends ControlInterface, ReduxComponentInterface {
  multiline: boolean;
  formInstanceId: string;
  formModal: any;
  index: number;
  view: boolean;
}

class ContactsTable extends React.PureComponent<TableProps> {
  onEditClick = (event: MouseEvent, rowIndex: number) => {
		event.preventDefault();
		const { actions, value, formInstanceId, index } = this.props;
    actions.toggleModal(true, 'newContactModal', {edit: true, rowIndex:rowIndex, rowValue: value[index].contacts[rowIndex], value: value}, formInstanceId);
	};

	onDeleteClick = (event: MouseEvent, rowIndex: number) => {
		event.preventDefault();
		const { actions, name, index, formInstanceId, value } = this.props;
    let contacts = remove(rowIndex, 1, value[index].contacts);
    let finalValue = JSON.parse(JSON.stringify(value));
    finalValue[index] = {...finalValue[index], contacts};
    actions.toggleModal(true, 'deleteAresContactsModal', {callback: () => actions.onFormChange(formInstanceId, [name], finalValue)}, formInstanceId);
	};

  handleContacts = () => {
    const { actions, formInstanceId } = this.props;
    actions.toggleModal(true, 'newContactModal', null, formInstanceId);
  };
  render() {
    const { index, value, view } = this.props;
    return (
      <Table>
        {!view && (
          <caption>
            <Fab onClick={this.handleContacts} size="small" color="primary" aria-label={'Přidat nový kontakt'}>
              <Add />
            </Fab>
          </caption>
        )}
        <TableHead>
          <TableRow>
            <TableCell>{window.Alfresco.messages.global['label.companyname']}</TableCell>
            <TableCell>{window.Alfresco.messages.global['label.companytelephone']}</TableCell>
            <TableCell>{window.Alfresco.messages.global['button.view.email']}</TableCell>
            <TableCell>{window.Alfresco.messages.global['label.note']}</TableCell>
            {!view && (<TableCell>{window.Alfresco.messages.global['label.actions']}</TableCell>)}
          </TableRow>
        </TableHead>
        <TableBody>
          {value?.[index]?.contacts.length > 0 &&
            value?.[index]?.contacts.map((it: any, index: number) => (
              <TableRow key={index}>
                <TableCell>{it?.name}</TableCell>
                <TableCell>{it?.phone}</TableCell>
                <TableCell>{it?.email}</TableCell>
                <TableCell>{it?.note}</TableCell>
                {!view && (
                  <TableCell>
                    <Icon style={{cursor: "pointer"}} fontSize="small" className="fas fa-trash-alt action-button-formtable" onClick={(event: MouseEvent) => this.onDeleteClick(event, index)} />
                    <Icon style={{marginLeft: "5px", cursor: "pointer"}} fontSize="small" className="fas fa-pen action-button-formtable" onClick={(event: MouseEvent) => this.onEditClick(event, index)} />
                  </TableCell>)}
              </TableRow>
            ))}
          {value?.[index]?.contacts.length === 0 && (
            <TableRow>
              <TableCell colSpan={4}>{window.Alfresco.messages.global['edocat.fake-admin.table.no-results']}</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({ toggleModal, onFormChange }, dispatch),
});

export default connect(null, mapDispatchToProps)(ContactsTable);
